import { gql } from '@apollo/client';

export const procedureStatusColorsQuery = gql`
  query procedureStatusColors {
    procedureStatusColors {
      status
      color
    }
  }
`;

export const setProcedureStatusColorsMutation = gql`
  mutation setProcedureStatusColors($colors: [ProcedureStatusColorInput!]!) {
    setProcedureStatusColors(colors: $colors) {
      status
      color
    }
  }
`;

export default {
  list: procedureStatusColorsQuery,
  set: setProcedureStatusColorsMutation,
};
